import React, { Fragment } from 'react';
// utils
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import ResourcePreview from '../../../components/ResourcePreview/ResourcePreview';
import ResourcesPlaceholder from './RecourcesPlaceholder';
// styles
import styles from './ResourcesGrid.mod.css';

const getTitle = type => {
  switch (type) {
    case 'recovery':
      return 'Videos';
    case 'worksheets':
      return 'Other websites';
    case 'saved':
      return 'Articles, infographics and additional research';
    case 'articles':
      return 'Saved content from the modules';
    default:
      return 'My favorites';
  }
};

const ResourcesGrid = ({ resources, isLoading, type }) => {
  const hasResources = Array.isArray(resources) && resources.length > 0;
  return (
    <Fragment>
      <h2 className={styles.sectionTitle}>{getTitle(type)}</h2>
      {!isLoading && (
        <div className={styles.dataContainer}>
          {hasResources &&
            resources.map((resource, index) => (
              <ResourcePreview
                className={styles.preview}
                key={index}
                resource={resource}
              />
            ))}
          {!hasResources && <ResourcesPlaceholder type={type} />}
        </div>
      )}
    </Fragment>
  );
};

ResourcesGrid.propTypes = {
  resources: T.array,
  type: T.string
};

export default connect(
  state => ({
    resources: state.resources.resources,
    isLoading: state.resources.isLoading
  }),
  null
)(ResourcesGrid);



// WEBPACK FOOTER //
// ./src/containers/Resources/components/ResourcesGrid.jsx